var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconJava48Line = function SvgIconJava48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.33 23.3c-1.69-1.2-2.64-2.87-2.69-4.72-.05-1.97.94-3.85 2.78-5.31 1.97-1.55 2.03-3.72 2.03-3.74h3.4c0 .15-.04 3.82-3.33 6.41-.98.77-1.51 1.68-1.49 2.55.02.96.7 1.63 1.26 2.03l-1.97 2.77.01.01ZM24.47 21.86c-1.13-2-.97-3.63-.63-4.64.8-2.38 3.15-3.46 3.41-3.57l1.35 3.12-.67-1.56.69 1.56c-.34.15-1.29.73-1.56 1.55-.17.52-.05 1.14.37 1.87l-2.96 1.68v-.01ZM28.06 24.42h-14v3.4h14v-3.4ZM28.06 29.75h-11v3.4h11v-3.4ZM36 35.08H12v3.4h24v-3.4ZM29.94 33.15v-3.4a2.3 2.3 0 0 0 0-4.6v-3.4c3.14 0 5.7 2.56 5.7 5.7s-2.56 5.7-5.7 5.7Z",
    fill: "current"
  })));
};
export default SvgIconJava48Line;